import React, { Component } from "react";
import { connect } from "react-redux";
import { WEB_FONTS_LOADED, WP_FOOTER_LOADED } from "./actions";
import { REQUEST_PRODUCT } from "containers/ProductDetails/actions";
import { Route, Switch, withRouter } from "react-router-dom";
import ProductDetails from "containers/ProductDetails";
import Catalog from "containers/Catalog";
import DataPreloader from "components/DataPreloader";
import AnimatedMasoniteLogo from "components/AnimatedMasoniteLogo";
import "./index.scss";

export class App extends Component {
    componentWillMount() {
        window.addEventListener("wpFooterLoaded", () => {
            this.props.dispatch({ type: WP_FOOTER_LOADED });
        });
    }

    componentDidMount = () => {
    };

    componentDidUpdate(prevProps) {
    }

    productRoutes = () => {
        return ["id", "title", "dimensions"]
            .map((param, i, params) => {
                const paramsStr = params
                    .map(param => `:${param}`)
                    .filter((param, j) => j < i + 1)
                    .reverse()
                    .join("/");

                return (
                    <Route
                        key={paramsStr}
                        path={`${this.props.routeRoots.productDetails}/${paramsStr}`}
                        render={props => (
                            <DataPreloader
                                action={() => {
                                    this.props.dispatch({
                                        type: REQUEST_PRODUCT,
                                        payload: props.match.params.id
                                    });
                                }}
                                loading={this.props.loading.productDetails}
                                loader={() => <AnimatedMasoniteLogo />}
                            >
                                <ProductDetails />
                            </DataPreloader>
                        )}
                    />
                );
            })
            .reverse();
    };

    catalogRoutes = pathPrefix => {
        let arrForMap = [];

        for (let i = 0; i < 42; i++) {
            arrForMap.push(i);
        }

        return [arrForMap].map((param, i, params) => {
            const paramsStr = params
                .map(param => {
                    return param === 0 ? `:hashes` : `:${param}`;
                })
                .filter((param, j) => j < i)
                .reverse()
                .join("/");

            const path = pathPrefix + (paramsStr ? `/${paramsStr}` : "");

            return (
                <Route
                    key={paramsStr}
                    path={path}
                    render={props => {
                        const isInterior = new RegExp(
                            this.props.interiorRoute,
                            "g"
                        );
                        const pathPrefix = props.location.pathname.match(
                            isInterior
                        )
                            ? this.props.interiorRoute
                            : this.props.allDoorsRoute;
                        const type = props.location.pathname.match(isInterior)
                            ? "interior"
                            : "all";

                        return <Catalog type={type} pathPrefix={pathPrefix} />;
                    }}
                />
            );
        });
    };

    render() {
        return (
            <div style={{ minHeight: "75vh" }}>
                <Switch>
                    {this.catalogRoutes(this.props.interiorRoute)}
                    {this.catalogRoutes(this.props.exteriorRoute)}
                    {this.catalogRoutes(this.props.allDoorsRoute)}
                    {this.productRoutes()}
                </Switch>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    loading: {
        catalog: state.catalog.loading,
        productDetails: state.productDetails.loading
    },
    routeRoots: {
        catalog: state.catalog.routeRoot,
        productDetails: state.productDetails.routeRoot
    },
    allDoorsRoute: state.catalog.allDoorsRoute,
    interiorRoute: state.catalog.interiorRoute,
    exteriorRoute: state.catalog.exteriorRoute
});

export default withRouter(connect(mapStateToProps)(App));
